{
  "api": {
    "messages": {
      "something_bad_happened": "Něco se pokazilo"
    }
  },
  "auth": {
    "applications": "Aplikace",
    "language": "Jazyk",
    "login": "Přihlásit se",
    "login_required_dialog": {
      "title": "Pro tuto akci je nutné přihlášení"
    },
    "login_session_expired_dialog": {
      "continue_working": "Pokračovat v práci",
      "title": "Relace přihlášení vypršela"
    },
    "logout": "Odhlásit se",
    "not_allowed_to_use_app": "Proto nemáte přístup k aplikaci",
    "not_authorized_to_use_app": "Nejste autorizován pro tuto aplikaci",
    "not_logged_in": "Nejste přihlášen",
    "password": "Heslo",
    "user_logged_out": "Byl jste odhlášen z důvodu nečinnosti",
    "username": "Uživatelské jméno"
  },
  "browser": {
    "common": {
      "open_in_overlay": "Otevřít v plovoucím okně",
      "view_in_browser": "Prohlížet ve čtečce",
      "view_in_mirador": "Prohlížet v Miradoru"
    },
    "copy_detail_dialog": {
      "copy_browser_url": "URL pro otevření dokumentu zde a na této stránce/foliu",
      "copy_image_url": "URL obrazového souboru",
      "title": "Kopírování",
      "url_saved_to_clipboard": "URL zkopírováno do schránky"
    },
    "copy_manifest_dialog": {
      "copy_browser_url_title": "Kopírování URL do čtečky",
      "copy_enhanced_manifest_url": "URL obohaceného manifestu",
      "copy_manifest_url_title": "Kopírování URL manifestu",
      "copy_original_manifest_url": "URL původního manifestu",
      "url_saved_to_clipboard": "URL zkopírováno do schránky"
    },
    "copyright": {
      "attribution": "Atribuce",
      "license": "Licence"
    },
    "crop_dialog": {
      "copy_image_url": "URL výřezu zkopírováno do schránky"
    },
    "detail": {
      "back_to_gallery": "Zpět do galerie",
      "cancel": "Missing value for 'browser.detail.cancel'",
      "confirm": "Missing value for 'browser.detail.confirm'",
      "copy_image_url": "Kopírovat URL obrázku",
      "copy_manifest_url": "Kopírovat URL manifestu",
      "copy_url": "Kopírovat URL",
      "crops_and_annotations": "Výřezy a anotace",
      "delete_crop": "Odstranit výřez",
      "download_crop": "Stáhnout výřez",
      "download_image": "Stáhnout obrázek",
      "fit_to_window": "Přizpůsobit obrazovce",
      "fullscreen": "Celá obrazovka",
      "image_url_saved_to_clipboard": "URL obrazu zkopírováno do schránky",
      "modification": "Modifikace",
      "open_url_in_new_tab": "Otevřít URL v nové záložce",
      "rotate_left": "Otočit vlevo",
      "rotate_right": "Otočit vpravo",
      "tools": {
        "box": "Výřez - obdélník",
        "circle": "Kruh",
        "lineString": "Řetězec",
        "modify": "Modifikace",
        "move": "Posun",
        "point": "Bod",
        "polygon": "Výřez - polygon"
      },
      "zoom_in": "Přiblížit",
      "zoom_out": "Oddálit"
    },
    "detail_annotation": {
      "available_in_collections": "Dostupné v kolekcích",
      "copy_crop_url": "Kopírovat URL výřezu",
      "crop": "Výřez",
      "crop_list": "Vybrané výřezy",
      "download_crop": "Stáhnout výřez",
      "edit": "Upravit",
      "logged_in_message": "Ke stránce můžete vytvořit výřez nebo anotaci.",
      "logged_out_message": "Ke stránce můžete vytvořit výřez nebo anotaci, když se přihlásíte.",
      "show_details": "Zobrazit podrobnosti"
    },
    "frame_actions": {
      "description": "Metadata",
      "details": "Detailní obrazy",
      "edition_text": "Text edice",
      "gallery": "Galerie",
      "open_manifest": "Otevřít IIIF manifest",
      "relation": "Katalog",
      "see_also": "Související",
      "switch_to_mirador": "Přepnout do Miradoru",
      "toggle_structure": "Obsah"
    },
    "gallery": {
      "copy_document_url": "Kopírovat URL dokumentu",
      "copy_manifest_url": "Kopírovat URL IIIF manifestu"
    },
    "gallery_mode": {
      "basic": "Galerie",
      "one_column_full_height": "Přizpůsobit výšce obrazovky",
      "one_column_max_height": "Přizpůsobit šířce obrazovky"
    },
    "home": {
      "welcome_message": "Přetáhněte nebo vložte URL adresu IIIF manifestu"
    },
    "info": {
      "close_drawer": "Skrýt obsah a další metadata",
      "copyright": "Copyright",
      "iiif_manifest_has_no_content": "Obsah dokumentu není součástí metadat manifestu.",
      "links": "Odkazy",
      "metadata": "Metadata",
      "open_drawer": "Zobrazit obsah a další metadata",
      "related": "Související",
      "relation": "Katalog",
      "resource": "Zdroj",
      "see_also": "Související",
      "structure": "Obsah",
      "title": "Titul"
    },
    "messages": {
      "browser_feature_not_enabled": "Funkcionalita \"Čtečka/Browser\" není aktivována. Pro aktivaci se prosím obraťte na poskytovatele služby.",
      "crop_has_to_be_inside_image": "Ořez musí být v oblasti obrazu",
      "crop_is_not_valid": "Ořez není validní",
      "error_while_loading_manifest": "Došlo k chybě při načítání manifestu",
      "invalid_manifest_type": "Neplatný typ manifestu. Čtečka podporuje pouze typ Manifest"
    },
    "open_manifest_dialog": {
      "manifest_url": "URL manifestu",
      "title": "Otevřít IIIF manifest"
    },
    "plugin": {
      "back_to_gallery": "Zpět do galerie",
      "next_image": "Následující obrázek",
      "prev_image": "Předchozí obrázek"
    },
    "relation": {
      "services": {
        "castor": "Katalogové záznamy"
      }
    },
    "see_also": {
      "links": "Odkazy",
      "related_catalogue_records": "Související záznamy v katalozích"
    },
    "view_mode": {
      "show_all": "Zobrazit všechny",
      "show_only_favorites": "Zobrazit jen oblíbené"
    }
  },
  "browser_mirador": {
    "frame_actions": {
      "switch_to_browser": "Přepnout do Čtečky"
    }
  },
  "castor": {
    "clear_input": "Smazat vstup",
    "date_range_end": "Datum konec",
    "date_range_start": "Datum začátek",
    "field": "Pole",
    "field_select": {
      "common": "Společné",
      "other": "Ostatní",
      "processed": "Zpracované",
      "unprocessed": "Nezpracované"
    },
    "field_types": {
      "DATE": "Datum",
      "KEYWORD": "Klíčové slovo",
      "STRING": "String",
      "TEXT": "Text"
    },
    "logical_operators": {
      "AND": "A",
      "NOT": "BEZ",
      "OR": "NEBO"
    }
  },
  "catalog": {
    "buttons": {
      "back": "Zpět",
      "download_from_dropbox": "Stáhnout z Dropboxu",
      "download_shown_preview": "Stáhnout zobrazený náhled",
      "set_active": "Nastavit jako aktivní"
    },
    "compare": {
      "compare_with": "Porovnat s",
      "compare_with_detail": "Otevřené záznamy",
      "compare_with_itself": "Porovnat se sebou samým",
      "compare_with_search_result": "Výsledky vyhledávání",
      "comparison": "Porovnání",
      "load_record": "Načíst záznam",
      "not_supported_on_mobile": "Porovnání není dostupné na mobilním zařízení. Pomocí odkazů níže lze zobrazit první a druhý záznam."
    },
    "dashboard": {
      "search": "Vyhledat"
    },
    "detail": {
      "actions": {
        "compact_header": "Kompaktní hlavička",
        "compare": "Porovnat",
        "copy_url": "Kopírovat URL dokumentu",
        "download": "Stáhnout",
        "full_header": "Celá hlavička",
        "fullscreen": "Celá obrazovka",
        "open_overlay": "Otevřít v okně",
        "pin": "Připnout",
        "share_on_facebook": "Sdílet na Facebook",
        "share_on_twitter": "Sdílet na Twitter",
        "view_in_browser": "Prohlížet ve čtečce"
      },
      "close": "Přejít na výsledky vyhledávání",
      "delete_details": "Smazat detaily",
      "image_types": {
        "archive": "Fotografie v AV Archivu ČOV",
        "archive_download": "Fotografie v AV Archivu ČOV (ke stažení)",
        "dropbox": "Fotografie z Dropboxu (ke stažení)",
        "ftp_photo": "Rychlá fotografie"
      },
      "item_title": "Detail",
      "no_details_opened": "Nemáte otevřené žádné detaily",
      "title": "Detaily"
    },
    "detail_item": {
      "similar_records": "Mohlo by se vám líbit"
    },
    "details_delete_confirm": {
      "message": "Opravdu chcete smazat detaily?",
      "title": "Smazání detailů"
    },
    "edit_search_result_dialog": {
      "logical_operator": "Logický operátor k předchozímu dotazu",
      "search": "Vyhledat",
      "title": "Upravit dotaz"
    },
    "facet": {
      "clear": "Resetovat filtry",
      "facet_filter_title": "Zadejte hledaný výraz.",
      "no_filter_available": "Není dostupný žádný filtr",
      "no_filter_available_value": "Není dostupný žádný filtr pro \"{{value}}\"",
      "title": "Rejstříkové vyhledávání",
      "unique_value_count": "Zobrazeno prvních {{count}} hodnot z {{unique}}"
    },
    "facet_list": {
      "title": "Rejstřík"
    },
    "facet_map": {
      "title": "Mapa"
    },
    "facet_register": {
      "title": "Rejstřík"
    },
    "facet_statistics": {
      "title": "Statistiky",
      "unique_values": "Obsahuje <strong>{{value}}</strong> unikátních hodnot",
      "with_value": "{count, plural, =0 {S hodnotou (0 hodnot)} =1 {S hodnotou (1 hodnota)} =2 {S hodnotou (2 hodnoty)} =3 {S hodnotou (3 hodnoty)} =4 {S hodnotou (4 hodnoty)} other {S hodnotou (# hodnot)}}",
      "without_value": "{count, plural, =0 {Bez hodnoty (0 záznamů)} =1 {Bez hodnoty (1 záznam)} =2 {Bez hodnoty (2 záznamy)} =3 {Bez hodnoty (3 záznamy)} =4 {Bez hodnoty (4 záznamy)} other {Bez hodnoty (# záznamů)}}"
    },
    "facet_timeline": {
      "after_count": "Obsahuje <strong>{{value}}</strong> záznamů po rozsahu",
      "before_count": "Obsahuje <strong>{{value}}</strong> záznamů před rozsahem",
      "date_range": "Časové období",
      "interval_name": "Interval",
      "interval_value": "Rozsah seskupení",
      "intervals": {
        "DAY": "Den",
        "MONTH": "Měsíc",
        "YEAR": "Rok"
      },
      "title": "Časová osa"
    },
    "facet_tree": {
      "title": "Stromeček"
    },
    "form_search": {
      "add": "Přidat vyhledávací položku",
      "form_settings": {
        "advancedFormSearch": "Nastavení interpretace textu dotazu",
        "core": "Jádro",
        "distanceSearch": "Hledání na vzdálenost"
      },
      "logical_operator": "Logický operátor",
      "query": "Dotaz",
      "reset": "Resetovat vyhledávání",
      "search": "Vyhledat",
      "search_settings": {
        "asciiSearch": "Vyhledávání bez diakritiky",
        "asterLeft": "Automatická hvězdička zleva",
        "asterRight": "Automatická hvězdička zprava",
        "stem": "Stematizace",
        "stopwords": "Slovník nevýznamných slov",
        "synonyms": "Slovník synonym"
      },
      "title": "Hledat v"
    },
    "header": {
      "maximize": "Maximalizovat",
      "minimize": "Minimalizovat"
    },
    "image_preview": {
      "counts_towards_limit": "Počítá se do limitu",
      "download": "Stáhnout",
      "format": "Formát",
      "format_size": "Rozměr",
      "height": "Výška",
      "image_crop_download_options": "Možnosti ořezu a stažení v přednastavených formátech",
      "image_crop_message": "Fotografii si můžete stáhnout v některém z předpřipravených formátů.",
      "image_download_options": "Možnosti stažení celé fotografie",
      "license": "Licence",
      "messages": {
        "already_downloaded": "Fotografie dnes již byla stažena. Opakované stažení se dnes nezapočítává do limitu / nebude zpoplatněno.",
        "can_directly_download_from_dropbox": "Soubor lze stáhnout přímo z Dropboxu.",
        "can_download_from_archive": "Fotografii lze stáhnout z archivu.",
        "cant_download_from_archive": "Tato fotografie je umístěná v archivu a zatím je k dispozici pouze náhled. Pokud máte zájem o tuto fotografii, kontaktujte prosím správce AV Archivu ČOV.",
        "free_downloads_left": "Zbývá bezplatných stažení",
        "no_download_role": "Pokud máte zájem o stažení této fotografie ve vyšším rozlišení, kontaktujte prosím ČOV.",
        "no_free_downloads_left": "Limit dnešních bezplatných stažení dnes je vyčerpán. Obnoví se po půlnoci.",
        "paid_downloads_allowed_no_free_left": "Limit bezplatných stažení je pro dnešek vyčerpán. Stažení bude vyúčtováno dle platné smlouvy."
      },
      "open_in_browser": "Prohlížet ve čtečce",
      "tabs": {
        "crop": "Formátované",
        "image_download": "Stažení fotografie"
      },
      "watermark": "Vodoznak",
      "watermark_position": "Umístění loga",
      "watermark_source": "Logo",
      "width": "Šířka"
    },
    "lightbox": {
      "next_image": "Další fotka",
      "next_page": "Další stránka",
      "open": "Otevřít v lightboxu",
      "open_detail": "Otevřít detail",
      "prev_image": "Předchozí fotka",
      "prev_page": "Předchozí stránka"
    },
    "messages": {
      "castor_not_authorized": "<b>Nedostatečná oprávnění</b>: Pro tento záznam nemáte dostatečná oprávnění.",
      "castor_record_not_found": "<b>Upozornění</b>: Některé otevřené záznamy byly z katalogu odebrány, a proto již nelze zobrazovat jejich detailní karty.",
      "castor_search_not_authorized": "<b>Nedostatečná oprávnění</b>: Pro toto vyhledávání nemáte dostatečná oprávnění.",
      "comparing_same_records": "Porovnávají se stejné záznamy",
      "detail_url_copied": "URL záznamu zkopírováno do schránky",
      "found_because": "Nalezeno, protože",
      "no_items": "Nejsou dostupné žádné položky",
      "no_results": "Žádné výsledky",
      "record_already_pinned": "Záznam \"<b>{{ value }}</b>\" je již připnutý",
      "records_already_compared": "Záznamy \"<b>{{ value1 }}</b>\" a \"<b>{{ value2 }}</b>\" se již porovnávají",
      "sort_field_not_available": "neuvedeno"
    },
    "multi_image_download": {
      "building_zip": "Kompletace zip balíčku",
      "cancel_selection": "Vyprázdnit výběr",
      "confirm_cancel_download": "Opravdu chcete zrušit stahování?",
      "confirm_cancel_selection": "Opravdu chcete zrušit výběr fotek?",
      "copy_page_url": "Kopírovat URL balíčku fotografií",
      "download": "Stáhnout",
      "download_done": "Hotovo",
      "downloading_images": "Stahování obrázků",
      "failed_images": "Některé fotografie ({{count}}) nebylo možno do balíčku přidat.",
      "index": "Index",
      "page_url_copied": "Odkaz pro stažení zip souboru balíčku fotografií byl úspěšně zkopírován do schránky.",
      "quality": "Kvalita",
      "resolution": "Rozlišení",
      "show_detail": "Zobrazit záznam",
      "start_download": "Zahájit stahování",
      "title": "Hromadné stahování",
      "unselect": "Odebrat z výběru",
      "watermark": "Vodoznak",
      "zip_download_lifetime": "Platnost odkazu: {{time}}",
      "zip_name": "Název"
    },
    "news": {
      "no_items": "Nejsou dostupné žádné novinky",
      "title": "Novinky"
    },
    "result": {
      "copy_search_query_btn": "Kopírovat dotaz",
      "copy_search_query_msg": "Odkaz na dotaz byl zkopírován do schránky",
      "delete_result_items": "Smazat výsledky vyhledávání",
      "edit_search_result_btn": "Upravit výsledky vyhledávání",
      "hide_filters": "Skrýt filtry",
      "show_filters": "Filtrovat výsledky vyhledávání",
      "title": "Počet výsledků"
    },
    "result_list": {
      "check_all": "Označit vše k hromadnému stahování",
      "disable_multi_image_download": "Zrušit označení k hromadnému stahování",
      "enable_multi_image_download": "Označit k hromadnému stahování",
      "mode": {
        "basic": "Zobrazit v řádcích",
        "basic-compact": "Zobrazit v řádcích - kompaktně",
        "masonry": "Masonry layout",
        "masonry-simple": "Masonry layout",
        "tile": "Zobrazit jako tabulku",
        "tile-single-column": "Zobrazit po jednom záznamu",
        "tile-single-column-simple": "Zobrazit po jednom záznamu"
      },
      "open_sort": "Řadit výsledky vyhledávání",
      "title": "Výsledky vyhledávání",
      "uncheck_all": "Zrušit označení všeho k hromadnému stahování"
    },
    "result_sort": {
      "default_sort": "Výchozí řazení",
      "dir": {
        "asc": "Vzestupně",
        "desc": "Sestupně"
      },
      "sort": "Seřadit",
      "title": "Řazení"
    },
    "results_delete_confirm": {
      "message": "Opravdu chcete smazat výsledky vyhledávání?",
      "title": "Smazání výsledků vyhledávání"
    },
    "routes": {
      "dashboard_default": "Vyzkoušejte",
      "desktop": {
        "detail_default": "Detaily",
        "search_default": "Vyzkoušejte",
        "search_map": "Vyhledávání v mapě",
        "search_result": "Vyhledávání"
      },
      "detail_default": "Detaily",
      "mobile": {
        "detail_default": "Detaily",
        "search_default": "Vyhledávací formulář",
        "search_map": "Vyhledávání v mapě",
        "search_result": "Výsledky vyhledávání"
      },
      "news_default": "Novinky",
      "search_default": "Vyhledávání",
      "search_map_default": "Vyhledávání v mapě",
      "search_result_desktop": "Vyhledávání",
      "search_result_mobile": "Výsledky vyhledávání",
      "settings_default": "Nastavení"
    },
    "search": {
      "asterisks_ignored": "Hvězdičky jsou ignorovány",
      "btn_search": "Vyhledat",
      "preprepared_queries": "Předpřipravené dotazy",
      "switch_to_advanced_mode": "Pokročilé",
      "switch_to_simple_mode": "Jednoduché"
    },
    "search_form_simple": {
      "label": "Vyhledávací dotaz"
    },
    "search_history": {
      "title": "Historie vyhledávání"
    },
    "search_map": {
      "query": "Vyhledat lokality ve výřezu",
      "search": "Vyhledat",
      "show_list": "Zobrazit seznam",
      "title": "Vyhledávání pomocí mapy"
    },
    "settings": {
      "detail_compact_header": "Zobrazovat kompaktní hlavičku",
      "detail_lock": "Nepřidávat nový tab při otevírání záznamu",
      "detail_title": "Detaily",
      "result_lock": "Nepřidávat nový tab pro výsledky hledání",
      "result_title": "Výsledky vyhledávání",
      "search_default_logical_operator": "Výchozí logický operátor",
      "search_form_mode": "Režim vyhledávacího formuláře",
      "search_form_modes": {
        "advanced": "Pokročilý",
        "simple": "Jednoduchý"
      },
      "search_title": "Vyhledávání",
      "title": "Nastavení"
    },
    "titles": {
      "comparison": "Porovnání",
      "default_tab_label": "Záznam",
      "number_of_results": "Počet výsledků",
      "pinned_details": "Připnuté detaily",
      "query_to": "Dotaz do",
      "search": "Vyhledávání",
      "summaryTabLabel": "Missing value for 'catalog.titles.summaryTabLabel'",
      "topics": "Témata"
    },
    "topic": {
      "no_results": "Nebyly nalezeny žádné výsledky",
      "not_found": "Téma s id <b>{{id}}</b> neexistuje"
    },
    "virtual_keyboard": {
      "layouts": {
        "cyrillica": "Cyrilika",
        "old_greek_large": "Starořečtina velká písmena",
        "old_greek_small": "Starořečtina malá písmena"
      }
    }
  },
  "cookie_consent": {
    "consent_modal": {
      "accept_all": "Přijmout vše",
      "deny_all": "Odmítnout vše",
      "description": "Pro nejlepší funkčnost našich webových stránek a nejlepší uživatelský zážitek doporučujeme povolit všechny typy cookies. <button type=\"button\" data-cc=\"c-settings\" class=\"cc-link\">Výběr cookies</button>",
      "title": "Používáme cookies"
    },
    "settings_modal": {
      "accept_all_btn": "Potvrdit vše",
      "blocks": {
        "analytics": {
          "description": "Díky těmto cookies můžeme analyzovat chování uživatelů a zlepšovat použitelnost webové stránky.",
          "title": "Analytické cookies"
        },
        "intro": {
          "description": "Pro nejlepší funkčnost našich webových stránek a nejlepší uživatelský zážitek doporučujeme povolit všechny typy cookies. Detailní informace o jednotlivých cookies najdete v Zásadách ochrany osobních údajů.",
          "title": "Povolení jednotlivých typů cookies"
        },
        "necessary": {
          "description": "Díky těmto cookies správně fungují odpovědní formuláře, ankety, kvízy a další důležité součásti webových stránek.",
          "title": "Nezbytné cookies"
        }
      },
      "close_btn_label": "Zavřít",
      "cookie_table_headers": {
        "col1": "Název",
        "col2": "Doména",
        "col3": "Expirace",
        "col4": "Popis"
      },
      "reject_all_btn": "Odmítnout vše",
      "save_settings_btn": "Uložit moje nastavení",
      "title": "Přizpůsobit nastavení cookies"
    }
  },
  "dashboard": {
    "buttons": {
      "back": "Missing value for 'dashboard.buttons.back'",
      "cancel": "Missing value for 'dashboard.buttons.cancel'",
      "search": "Missing value for 'dashboard.buttons.search'"
    },
    "messages": {
      "no_records_found": "Missing value for 'dashboard.messages.no_records_found'"
    },
    "paginator": {
      "first_page": "Missing value for 'dashboard.paginator.first_page'",
      "items_per_page": "Missing value for 'dashboard.paginator.items_per_page'",
      "last_page": "Missing value for 'dashboard.paginator.last_page'",
      "next_page": "Missing value for 'dashboard.paginator.next_page'",
      "of": "Missing value for 'dashboard.paginator.of'",
      "previous_page": "Missing value for 'dashboard.paginator.previous_page'"
    },
    "titles": {
      "available_editions": "Missing value for 'dashboard.titles.available_editions'",
      "content_overview": "Missing value for 'dashboard.titles.content_overview'",
      "editions": "Missing value for 'dashboard.titles.editions'",
      "filter": "Missing value for 'dashboard.titles.filter'",
      "resource": "Missing value for 'dashboard.titles.resource'"
    }
  },
  "dialog": {
    "buttons": {
      "cancel": "Zrušit",
      "close": "Zavřít",
      "confirm": "Potvrdit",
      "save": "Uložit"
    }
  },
  "explorer": {
    "buttons": {
      "change_layout": "Změnit rozložení",
      "delete_entity": "Smazat entitu",
      "find_direct_relations": "Najít přímé vazby",
      "find_shortest_relation_all": "Najít všechny nejbližší souvislosti s",
      "find_shortest_relation_with": "Najít nejbližší souvislost s",
      "fullscreen": "Celá obrazovka",
      "help": "Nápověda",
      "load_all_relations": "Načíst všechny vztahy",
      "load_relation": "Načíst vztah",
      "load_relations": "Načíst vztahy",
      "load_relations_in_tab": "Načíst vztahy do záložek",
      "opened_entities": "Otevřené položky",
      "refresh_layout": "Obnovit rozložení",
      "restart": "Restartovat",
      "settings": "Nastavení",
      "show": "Zobrazit",
      "show_all": "Zobrazit vše",
      "undo": "Zpět"
    },
    "dashboard": {
      "show_exploration": "Zobrazit průzkum"
    },
    "entityTypes": {
      "Corporation": "Korporace",
      "Person": "Osoba",
      "Place": "Místo",
      "PlacePilgrim": "Poutní místo",
      "Print": "Kramářský tisk",
      "Song": "Píseň"
    },
    "entity_detail_dialog": {
      "add_all_to_graph": "Přidat všechny položky do grafu",
      "add_selected_to_graph": "Přidat vybrané položky do grafu",
      "default_catalog_title": "Katalog",
      "entity_has_no_description": "Položka nemá žádný popisek",
      "overview": "Souhrn",
      "relations": "Vztahy",
      "relations_added_to_graph": "Vztahy byly přidány do grafu"
    },
    "exploration_manager_list": {
      "delete": "Smazat",
      "edge_count": "Počet vazeb",
      "no_explorations_available": "Nejsou dostupné žádné průzkumy",
      "node_count": "Počet uzlů",
      "perform_search": "Provést vyhledávání"
    },
    "exploration_manager_page": {
      "exploration_manager": "Správa průzkumů"
    },
    "exploration_page": {
      "context": "Souvislosti",
      "graph": "Graf",
      "map": "Mapa"
    },
    "filter": {
      "only_highlighted": "Pouze zvýrazněné",
      "only_pinned": "Pouze připnuté"
    },
    "graph": {
      "automatic_centering": "Vycentrovat",
      "automatic_zoom": "Zobrazit celý graf",
      "cancel_centering": "Zrušit centrování",
      "delete_orphans": "Smazat sirotky",
      "show_minimap": "Zobrazit minimapu"
    },
    "messages": {
      "entity_already_in_graph": "Entita se již nachází v grafu",
      "entity_removed": "Entita byla odebrána z grafu",
      "graph_no_direct_paths_found": "Nebyly nalezeny žádné přímé cesty",
      "graph_no_path_found": "Cesta mezi entitami nebyla nalezena",
      "i_want_to_know_more_about": "Chci se dozvědět více o",
      "invalid_search": "Neplatné vyhledávání",
      "search_empty_result": "Nepodařilo se najít žádné záznamy",
      "something_bad_happened": "Něco se pokazilo"
    },
    "mime_types": {
      "image": "Obrázek",
      "pdf": "Pdf",
      "video": "Video"
    },
    "properties": {
      "URI": "URI",
      "atPosition": "Na pozici",
      "coverage": "Pokrytí",
      "date": "Datum",
      "dateCreated": "Datum vytvoření",
      "default": "Výchozí",
      "description": "Popisek",
      "duration": "Doba trvání",
      "edc": "edc",
      "format": "Formát",
      "genID": "genID",
      "generalDesc": "Obecný popis",
      "name": "Název",
      "note": "Poznámka",
      "roleID": "Role ID",
      "summary": "Shrnutí",
      "summary_en": "Shrnutí anglicky",
      "thumb": "Náhled",
      "thumbs": "Thumbs",
      "title": "Titulek",
      "title_en": "Titulek anglicky",
      "url": "URL",
      "view": "Náhled"
    },
    "relations": {
      "createdAt": "vytvořeno (kde)",
      "createdAt_rev": "bylo zde vytvořeno (co)",
      "createdBy": "vytvořil/a",
      "createdBy_rev": "vytvořeno (kým)",
      "isAbout": "pojednává o",
      "isAbout_rev": "je zmíněno v",
      "isPartOf": "je součástí",
      "isPartOf_rev": "obsahuje",
      "isSomehowRelated1": "má vazbu k",
      "isSomehowRelated1_rev": "má vazbu k",
      "isSomehowRelated2": "má vazbu k",
      "isSomehowRelated2_rev": "má vazbu k",
      "ownedAt": "uloženo (kde)",
      "ownedAt_rev": "bylo zde uloženo (co)",
      "ownedBy": "vlastněno (kým)",
      "ownedBy_rev": "vlastnil",
      "printedAt": "vytištěno (kde)",
      "printedAt_rev": "bylo zde vytištěno (co)",
      "printedBy": "vytištěno u",
      "printedBy_rev": "vytiskl/a",
      "publishedAt": "vydáno (kde)",
      "publishedAt_rev": "bylo zde vydáno (co)",
      "publishedBy": "vydáno u",
      "publishedBy_rev": "vydal/a",
      "soldAt": "k dostání (kde)",
      "soldAt_rev": "bylo zde prodáváno (co)",
      "soldBy": "k dostání u",
      "soldBy_rev": "prodával/a",
      "translatedAt": "přeloženo (kde)",
      "translatedAt_rev": "bylo zde přeloženo (co)",
      "translatedBy": "přeložil",
      "translatedBy_rev": "přeloženo (kým)",
      "workedIn": "byl/a činný/činná",
      "workedIn_rev": "byl/a zde činný/činná"
    },
    "search_form": {
      "search_input": "Vyhledávání",
      "type": "lidové kultuře"
    },
    "settings": {
      "hideEmptyRelations": "Skrýt entity bez vztahu",
      "mode": {
        "expert": "Expert",
        "standard": "Standard"
      },
      "showLabels": "Zobrazit plovoucí popisky"
    },
    "titles": {
      "legend": "Legenda",
      "loading_entities_in_progress": "Probíhá načítání entit",
      "mode": "Režim",
      "opened_entities": "Otevřené položky",
      "opened_tabs": "Otevřené záložky",
      "pdf": "PDF dokument",
      "properties": "Vlastnosti",
      "relation_filters": "Filtry vazeb",
      "relations": "Vztahy",
      "settings": "Nastavení",
      "user_guide": "Uživatelská příručka"
    },
    "type": "Typ",
    "visual_mode": "Režim zobrazení",
    "visual_modes": {
      "adjacency-list": "Seznam vztahů",
      "distance-matrix": "Matice vzdáleností",
      "graph": "Graf",
      "relation-matrix": "Matice vztahů"
    },
    "visual_representation": "Vizuální reprezentace"
  },
  "form": {
    "clear": "Vymazat",
    "delete": "Smazat",
    "errors": {
      "date_range_not_valid": "Rozsah datumu je neplatný",
      "required": "Toto pole je povinné"
    },
    "query": "Dotaz",
    "reset": "Resetovat",
    "save": "Uložit",
    "search": "Vyhledávání"
  },
  "frame": {
    "collapse": "Sbalit",
    "expand": "Rozbalit",
    "menu": "Rozcestník",
    "next": "Další",
    "overlay_button": "Správce plovoucích oken",
    "personal_content_plugin_button": "Oblíbené"
  },
  "fulltext": {
    "dashboard": {
      "message": "Vyhledejte si edici v aplikaci Katalog"
    },
    "edition": {
      "cancel_highlight": "Zrušit zvýraznění",
      "collapse_fragment_card": "Zúžit na polovinu",
      "context_information": "Kontextové informace",
      "expand_fragment_card": "Roztáhnout na celou šířku",
      "resources": "Související dokumenty"
    },
    "edition_context": {
      "creator": "Tvůrce",
      "date_created": "Datum vytvoření",
      "division_not_available": "Obsah edice není dostupný",
      "information": "Informace",
      "lang": "Jazyk",
      "other_information": "Další informace",
      "relations_on_editions": "Vztahy na edice",
      "relations_on_people": "Vztahy na osoby",
      "relations_on_resources": "Vztahy na předlohy",
      "table_of_contents": "Obsah",
      "title": "Titulek",
      "type": "Typ"
    },
    "fragment": {
      "continuation_of_the_text": "Pokračování textu",
      "next": "Další",
      "previous": "Předchozí",
      "previous_text": "Předchozí text"
    },
    "fragment_labels": {
      "LANG_Apparatus_entry": "Vstup kritického aparátu",
      "LANG_Corr_text": "Správný text",
      "LANG_Correction": "Korektura",
      "LANG_Lemma": "Lemma / základní text",
      "LANG_Orig_text": "Původní text",
      "LANG_Reading": "Varianta čtení",
      "LANG_note": "Poznámka"
    },
    "resource": {
      "no_resources": "Nepodařilo se dohledat žádnou digitální kopii."
    },
    "settings": {
      "font": "Font",
      "icon_size_in_edition": "Velikost ikon v edici",
      "sans_serif": "Bezpatkové",
      "serif": "Patkové",
      "text_size_in_edition": "Velikost textu v edici",
      "title": "Nastavení"
    }
  },
  "image_preview": {
    "messages": {
      "crop_has_to_be_inside_image": "Ořez musí být v oblasti fotografie"
    }
  },
  "keycloak_manager": {
    "client_detail": {
      "label": "Klient",
      "settings": "Nastavení"
    },
    "client_table": {
      "action": "Akce",
      "clientId": "Název",
      "description": "Popisek",
      "detail": "Detail",
      "label": "Klienti"
    },
    "delete_users_dialog": {
      "title": "Potvrdit smazání uživatelů"
    },
    "group_create_dialog": {
      "title": "Vytvořit skupinu"
    },
    "group_detail": {
      "group": "Skupina",
      "roles": "Role",
      "users": "Uživatelé"
    },
    "group_edit_dialog": {
      "title": "Upravit skupinu"
    },
    "group_form": {
      "name": "Název",
      "parent_id": "Nadřazená skupina"
    },
    "group_list": {
      "no_groups_available": "Nejsou dostupné žádné skupiny"
    },
    "group_member_list": {
      "next": "Další",
      "previous": "Předchozí"
    },
    "group_table": {
      "action": "Akce",
      "create_group": "Vytvořit skupinu",
      "default": "Výchozí?",
      "default_description": "Zaškrtnuté skupiny se automaticky přiřazují nově registrovaným/vytvořeným uživatelům.",
      "edit": "Upravit",
      "label": "Skupiny",
      "name": "Název",
      "path": "Cesta"
    },
    "reset_passwords_dialog": {
      "title": "Potvrdit reset hesel"
    },
    "role_create_dialog": {
      "title": "Vytvořit roli"
    },
    "role_detail": {
      "groups": "Skupiny",
      "role": "Role"
    },
    "role_edit_dialog": {
      "title": "Upravit roli"
    },
    "role_form": {
      "description": "Popisek",
      "name": "Název"
    },
    "role_list_page": {
      "create_role": "Vytvořit roli"
    },
    "role_table": {
      "action": "Akce",
      "confirm_delete": "Opravdu smazat?",
      "create_role": "Vytvořit roli",
      "delete": "Smazat",
      "description": "Popisek",
      "detail": "Detail",
      "edit": "Upravit",
      "name": "Název"
    },
    "routes": {
      "client_default": "Klienti",
      "group_default": "Skupiny",
      "role_default": "Role",
      "user_default": "Uživatelé"
    },
    "send_login_email_dialog": {
      "content": "Opravdu odeslat přihlašovací e-mail?",
      "title": "Odeslání přihlašovacího e-mailu"
    },
    "send_verify_email_dialog": {
      "content": "Opravdu odeslat verifikační e-mail?",
      "title": "Odeslání verifikačního e-mailu"
    },
    "user_detail": {
      "activate": "Aktivovat",
      "admin": "Admin",
      "deactivate": "Deaktivovat",
      "delete": "Smazat",
      "delete_confirm": "Potvrdit smazání uživatele",
      "groups": "Skupiny",
      "label": "Detail uživatele",
      "last_access": "Poslední přístup",
      "login": "Přihlášení",
      "reset_password": "Resetovat heslo",
      "reset_password_confirm": "Potvrdit reset hesla uživatele",
      "user_activated": "Uživatel byl aktivován",
      "user_deactivated": "Uživatel byl deaktivován"
    },
    "user_edit": {
      "company": "Firma",
      "email": "E-mail",
      "first_name": "Křestní jméno",
      "language": "Jazyk",
      "last_name": "Příjmení",
      "locales": {
        "cs": "Čeština",
        "en": "Angličtina"
      },
      "not_in_email_format": "Není ve formátu e-mailu",
      "reset": "Resetovat",
      "save": "Uložit",
      "this_field_is_not_required": "Missing value for 'keycloak_manager.user_edit.this_field_is_not_required'",
      "this_field_is_required": "Toto pole je povinné",
      "username": "Uživatelské jméno"
    },
    "user_list_page": {
      "action": "Akce",
      "activate": "Aktivovat",
      "company": "Firma",
      "create_user": "Vytvořit uživatele",
      "deactivate": "Deaktivovat",
      "delete": "Smazat",
      "email": "E-mail",
      "export_to_csv": "Export do CSV",
      "filters": "Filtry",
      "fullname": "Jméno",
      "login_email": "Přihlašovací e-mail",
      "reset": "Reset",
      "reset_password": "Resetovat heslo",
      "search": "Vyhledávání",
      "search_hint": "(podle uživ.jména, jména a emailu)",
      "selected": "Vybráno",
      "state": "Stav",
      "username": "Uživatelské jméno",
      "users": "Uživatelé",
      "verification_email": "Verifikační e-mail"
    }
  },
  "lana": {
    "actions": {
      "invenio_download_record": "Stáhnout záznam z Invenia",
      "invenio_upload_record": "Odeslat záznam do Invenia",
      "new_record": "Nový záznam",
      "open_record": "Otevřít záznam",
      "save_record": "Uložit záznam",
      "save_record_as": "Uložit záznam jako",
      "settings": "Nastavení"
    },
    "buttons": {
      "force_save": "Přesto uložit",
      "invenio_download_record": "Stáhnout záznam z Invenia",
      "invenio_upload_record": "Odeslat záznam do Invenia"
    },
    "file_chooser_dialog": {
      "format": "Formát",
      "open": "Otevřít",
      "upload_file": "Nahrát soubor"
    },
    "invenio_download_dialog": {
      "format": "Formát"
    },
    "invenio_upload_dialog": {
      "record_insert_info": "V Inveniu bude vytvořen nový záznam",
      "record_replace_info": "V Inveniu bude nahrazen existující záznam \"{{recordId}}\""
    },
    "new_record_dialog": {
      "create": "Vytvořit",
      "title": "Vytvoření záznamu"
    },
    "preview": {
      "mode": "Režim"
    },
    "routes": {
      "homepage": "Úvod"
    },
    "save_as_dialog": {
      "format": "Formát",
      "name": "Název",
      "name_hint": "Název uloženého souboru",
      "save_as": "Uložit jako",
      "title": "Uložit jako"
    },
    "schema_errors": {
      "OBJECT_MISSING_REQUIRED_PROPERTY": "Chybí povinné pole"
    },
    "schema_fields": {
      "fld_idno": "Idno",
      "fld_institution": "Instituce uložení",
      "fld_repository": "Úložiště",
      "fld_settlement": "Místo uložení"
    },
    "settings": {
      "show_guides": "Zobrazit guides",
      "show_menu": "Zobrazit menu",
      "show_preview": "Zobrazit náhled"
    },
    "titles": {
      "invenio_download_dialog": "Stažení záznamu z Invenia",
      "invenio_upload_dialog": "Nahrání záznamu do Invenia",
      "validation_errors": "Validační chyby"
    }
  },
  "merc": {
    "active_query": {
      "clear": "Vyčistit formulář",
      "clear_active_query_dialog_title": "Smazat aktivní dotaz?",
      "clear_form": "Missing value for 'merc.active_query.clear_form'",
      "copy_url": "Zkopírovat URL",
      "query": "Hlavní část dotazu",
      "query_parameters": "Zpřesnění dotazu - typ B (další parametry)",
      "query_refinement": "Zpřesnění dotazu - typ A",
      "refresh": "Obnovit",
      "save_query": "Uložit dotaz",
      "title": "Aktivní dotaz"
    },
    "buttons": {
      "cancel": "Zrušit",
      "save": "Uložit",
      "send": "Odeslat",
      "send_query": "Odeslat dotaz"
    },
    "common": {
      "active_facets": "Moje facety",
      "default_facets": "Implicitní facety",
      "facets": "Facety",
      "media_facets": "Facety pro přímé zpřesnění (media)",
      "other_facets": "Facety pro hlavní část dotazu (k použití v poli dotazu)"
    },
    "dialogs": {
      "active_facets": "Pokročilé facety",
      "add_favorite": "Přidat do oblíbených",
      "send_query": "Odeslání dotazu pro zpracování"
    },
    "facet": {
      "less": "Méně",
      "more": "Více",
      "no_facet_items": "Pro aktuální dotaz nejsou k dispozici žádné základní fasety.",
      "static_title": "Facety",
      "user_title": "Pokročilé facety",
      "values": "Hodnoty"
    },
    "favorite_query": {
      "delete": "Smazat",
      "delete_favorite_query_dialog_title": "Smazat uložený dotaz?",
      "extend_search_favorite_query_dialog_title": "Přidat uložený dotaz k aktivnímu dotazu?",
      "no_favorite_items": "Nemáte žádné uložené dotazy.",
      "search": "Vyhledat",
      "search_favorite_query_dialog_title": "Aktivovat uložený dotaz?",
      "title": "Uložené dotazy"
    },
    "form": {
      "errors": {
        "email": "E-mail musí být validní",
        "required": "Toto pole je povinné"
      }
    },
    "form_fields": {
      "contact_email": "Kontaktní e-mail",
      "custom_field": "Přidat fasetu (název podle EUROPEANA Search API)",
      "facet_limit": "Maximální počet načítaných hodnot",
      "favorite_query_name": "Titulek uloženého dotazu",
      "name": "Jméno",
      "organization": "Organizace",
      "short_description": "Krátký popisek"
    },
    "messages": {
      "mine_query_send": "Odesláno pro zpracování",
      "no_user_facets": "Nemáte nastaveny žádné pokročilé facety.",
      "user_facets_load_failed": "Nepodařilo se načíst pokročilé facety."
    },
    "query_fields": {
      "all": "Vše",
      "subject": "Předmět",
      "text": "Text",
      "title": "Titulek",
      "what": "Co",
      "when": "Kdy",
      "where": "Kde",
      "who": "Kdo"
    },
    "query_values": {
      "date": "Datum",
      "date_range": "Datum - rozsah",
      "geographical_range": "Geografický rozsah",
      "letter_range": "Rozsah písmen"
    },
    "result": {
      "no_result_items": "Není aktivní žádné vyhledávání",
      "title": "Náhled na vyhledané záznamy"
    },
    "search_form": {
      "clear": "Vyčistit formulář",
      "common_values": "Vzory pro zápisy hodnot",
      "field_selection": "Výběr polí",
      "fields": "Tematické oblasti",
      "query": "Hlavní část dotazu",
      "search": "Vyhledat",
      "title": "Vyhledávací formulář"
    }
  },
  "messages": {
    "language_change": "Jazyk byl úspěšně změněn",
    "query_could_not_be_parsed_for_view": "Nepodařilo se zpracovat dotaz pro zobrazení",
    "something_bad_happened": "Něco se pokazilo."
  },
  "overlay": {
    "close_all": "Zavřít všechny",
    "overlay_manager": "Správce plovoucích oken",
    "reset_all": "Reset"
  },
  "paginator": {
    "first_page": "První stránka",
    "items_per_page": "Počet záznamů na stránku",
    "last_page": "Poslední stránka",
    "next_page": "Další stránka",
    "of": "z",
    "previous_page": "Předchozí stránka"
  },
  "personal_content": {
    "add_nibble_to_collection_dialog": {
      "make_changes": "Provést změny",
      "note": "Poznámka",
      "title": "Přidat do kolekce"
    },
    "add_to_favorites_button": {
      "add_to_collections": "Přidat do kolekce",
      "add_to_favorites": "Přidat do oblíbených",
      "other_collections": "Ostatní uživatelé si oblíbili",
      "own_collections": "Moje kolekce",
      "own_favorites": "Moje oblíbené",
      "related_nibbles": "Související"
    },
    "buttons": {
      "add_collection": "Přidat kolekci",
      "add_owner": "Přidat vlastníka",
      "allow_iiif_access": "Povolit IIIF přístup",
      "back_to_collections": "Zpět na kolekce",
      "clear": "Smazat",
      "create_nibble": "Přidat položku",
      "delete_collection": "Smazat kolekci",
      "deny_iiif_access": "Zakázat IIIF přístup",
      "edit": "Upravit",
      "move": "Přesunout",
      "publish": "Publikovat",
      "remove_owner": "Odebrat vlastníka",
      "show_collection": "Náhled kolekce",
      "update_publish": "Aktualizovat publikované",
      "withdraw_collection": "Vzít zpět"
    },
    "collection": {
      "annotation": "Anotace",
      "collection_needs_update": "V kolekci byla provedena změna. Kolekci je nutno zaktualizovat.<br /> Zkopírujte si, prosím, rozpracované hodnoty do externího editoru, abyste nepřišli o rozpracovaná data.",
      "comments": "Komentáře",
      "coop": "Kooperace",
      "included_in_collections": "Zařazeno v kolekcích",
      "nibble_actions": {
        "COLL": "Otevřít kolekci",
        "CROP": "Nalistovat v digitální kopii",
        "DOC3IF": "Otevřít digitální kopii",
        "IMG": "Otevřít obrázek",
        "IMG3F": "Nalistovat v digitální kopii",
        "LINK": "Otevřít odkaz v nové záložce",
        "REC": "Otevřít záznam",
        "TXT": "Otevřít text",
        "VID": "Otevřít video"
      },
      "presentation": "Prezentace",
      "settings": "Nastavení",
      "update": "Aktualizovat"
    },
    "collection_coop": {
      "collection_owner": "Vlastník kolekce",
      "copy_link": "Zkopírovat odkaz",
      "coworkers": "Spolupracovníci",
      "create_invitation": "Vytvořit pozvánku",
      "end_invitation": "Ukončit pozvánku",
      "invitation": "Pozvánka",
      "invitation_closed": "Pozvánka uzavřena.",
      "invitation_opened": "Pozvánka otevřena.",
      "leave": "Odejít",
      "pass_ownership": "Předat vlastnictví",
      "remove_user": "Odebrat uživatele",
      "users": "Uživatelé"
    },
    "collection_settings_dialog": {
      "coop": "Kooperace",
      "properties": "Vlastnosti",
      "sharing": "Sdílení",
      "title": "Nastavení"
    },
    "collection_share": {
      "collection_has_not_public_manifest": "Kolekce nemá veřejný manifest.",
      "collection_has_public_manifest": "Kolekce má veřejný manifest.",
      "collection_not_published": "Kolekce není publikována.",
      "collection_published_with_update": "{{personal_content.collection_share.collection_published_without_update}} K dispozici je upravená verze.",
      "collection_published_without_update": "Kolekce byla publikována {{date}}.",
      "copy_collection_url": "Kopírovat URL",
      "disseminated": "Publikování",
      "publish": "Publikovat",
      "publish_manifest": "Zveřejnit manifest",
      "share_on_facebook": "Facebook",
      "share_on_twitter": "Twitter",
      "share_preview": "Náhled na sdílení",
      "show_browser_mirador": "Browser Mirador",
      "show_iiif_manifest": "IIIF manifest",
      "show_presentation_preview": "Zobrazit prezentaci",
      "storno_manifest": "Storno manifestu",
      "update_publish": "Aktualizovat publikované",
      "url_to_presentation_copied": "Url na prezentaci zkopírována",
      "withdraw_collection": "Vzít zpět"
    },
    "collection_summary": {
      "delete_collection": "Smazat kolekci",
      "edit_collection": "Upravit vlastnosti"
    },
    "collection_types": {
      "didactic": "Didaktické",
      "favorites": "Oblíbené",
      "general": "Kolekce",
      "trashbin": "Koš"
    },
    "coop": {
      "collection_join_successful": "Připojení do kolekce \"{{value}}\" bylo úspěšné",
      "collections": "Kolekce",
      "copy_coop_url": "URL na kooperaci zkopírováno do schránky",
      "events": {
        "collectionCoopClose": "Kooperativní režim pro kolekci neaktivní",
        "collectionCoopJoin": "Uživatel spolupracuje na kolekci",
        "collectionCoopLeave": "Uživatel přestal spolupracovat na kolekci",
        "collectionCoopOpen": "Kooperativní režim pro kolekci aktivní",
        "collectionCreate": "Kolekce vytvořena",
        "collectionDisseminate": "Kolekce zveřejněna",
        "collectionDisseminateManifest": "Manifest zveřejněn",
        "collectionRemove": "Kolekce odstraněna",
        "collectionUpdate": "Kolekce aktualizována",
        "collectionWithdraw": "Kolekce stažena",
        "collectionWithdrawManifest": "Manifest stažen",
        "nibbleChangePosition": "Pořadí položky změněno",
        "nibbleCopy": "Položka zkopírována",
        "nibbleCreate": "Položka vytvořena",
        "nibbleEditCollRelatedComment": "Komentář aktualizován u položky",
        "nibbleEditCollRelatedNote": "Anotace aktualizována u položky",
        "nibbleMove": "Položka přesunuta",
        "nibbleRemoveFromCollectionById": "Položka odebrána",
        "nibbleRemoveFromCollectionByServiceValue": "Položka odebrána",
        "nibbleUpdate": "Položka  aktualizována",
        "personalMessageSend": "Zpráva odeslána",
        "unknown": "Neočekávaná akce"
      },
      "filter": {
        "reset": "Reset",
        "submit": "Filtrovat",
        "title": "Filtr"
      },
      "in_collection": "v kolekci",
      "message": "Zpráva",
      "messages": "Zprávy",
      "online_users": "Online uživatelé",
      "origins": {
        "systemGenerated": "Generováno systémem",
        "userGenerated": "Vytvořeno uživatelem"
      },
      "priorities": {
        "high": "Vysoká priorita",
        "low": "Nízká priorita",
        "medium": "Střední priorita"
      },
      "total_message_count": "Celkový počet zpráv je {{value}}",
      "users": "Uživatelé",
      "write_message": "Napsat zprávu"
    },
    "create_edit_collection_dialog": {
      "create_collection": "Vytvořit kolekci",
      "edit_collection": "Upravit kolekci \"{{value}}\"",
      "properties": "Vlastnosti",
      "sharing": "Sdílení"
    },
    "dashboard": {
      "action": "Akce",
      "collection": "Kolekce",
      "coop": "Kooperace",
      "dateDisseminated": "Datum publikování",
      "dateUpdated": "Změněno",
      "disseminated": "Publikování",
      "edit": "Editovat",
      "edit_properties": "Upravit vlastnosti",
      "filter": "Název kolekce",
      "leave_coop": "Ukončit spolupráci",
      "name": "Název",
      "nested_collections": "Vnořené kolekce",
      "no_rows_matched": "Nejsou dostupná žádná data",
      "owner": "Vlastník",
      "presentation": "Prezentace",
      "public3if": "IIIF manifest",
      "title": "Přehled",
      "type": "Typ",
      "users": "Uživatelé"
    },
    "dialog": {
      "nibble_comments": {
        "discussion_solved": "Diskuze byla vyřešena"
      },
      "nibble_detail_dialog": {
        "actions": "Akce",
        "advanced_work": "Pokročilá práce",
        "browse_in_digital_copy": "Nalistovat v digitální kopii",
        "copy_url": "Kopírovat URL",
        "download": "Stáhnout",
        "edit": "Upravit",
        "in_collections": "V kolekcích",
        "open_digital_copy": "Otevřít digitální kopii",
        "open_link": "Otevřít odkaz",
        "open_on_youtube": "Otevřít na Youtube",
        "open_record": "Otevřít záznam"
      }
    },
    "edit_nibble_collection_note_dialog": {
      "annotation": "Anotace",
      "caption_not_defined": "[titulek neuveden]",
      "title": "Anotace"
    },
    "forms": {
      "collection_create_edit": {
        "credits": {
          "hint": "Text poděkování nebo jiná podobná informace",
          "label": "Poděkování"
        },
        "label": {
          "hint": "Název",
          "label": "Název"
        },
        "note": {
          "hint": "Uživatelská poznámka k obsahu",
          "label": "Poznámka"
        },
        "summary": {
          "hint": "Shrnutí obsahu, abstrakt",
          "label": "Shrnutí"
        },
        "thumb": {
          "hint": "URL reprezentativního náhledového obrázku",
          "label": "Náhledový obrázek"
        },
        "type": {
          "hint": "Zaměření obsahu",
          "label": "Typ"
        }
      },
      "collection_publish": {
        "license": {
          "hint": "CC licenční ujednání, pod kterým bude obsah publikován",
          "label": "Licence"
        },
        "pub_image_poster": {
          "hint": "URL obrazu, který je při prezentaci použit jako dominanta publikovaného obsahu, typicky je vstupním bodem",
          "label": "Obrázek plakátu"
        },
        "pub_label_enter": {
          "hint": "Popisek tlačítka 'VSTOUPIT'",
          "label": "Tlačítko vstoupit"
        },
        "pub_og_description": {
          "hint": "Krátký popisek pro potřeby sdílení, bude zobrazen při sdílení pod Názvem",
          "label": "Popisek"
        },
        "pub_og_lang": {
          "hint": "Převládající jazyk publikovaného obsahu",
          "label": "Jazyk"
        },
        "pub_tags": {
          "hint": "Čárkou oddělená klíčová slova (bude použito jako hashtagy)",
          "label": "Klíčová slova"
        },
        "pub_text_footerAdditional": {
          "hint": "Při publikování bude připojeno k patičce",
          "label": "Patička další"
        },
        "pub_text_footerMain": {
          "hint": "Při publikování bude zobrazeno v patičce",
          "label": "Patička"
        },
        "pub_text_mission": {
          "hint": "Krátký text poslání publikovaného obsahu (např. virtuální výstavy)",
          "label": "Poslání"
        },
        "pub_text_welcome": {
          "hint": "Při publikování bude zobrazeno jako krátký uvítací text",
          "label": "Uvítací text"
        },
        "template": {
          "hint": "Šablona pro prezentaci",
          "label": "Šablona"
        }
      },
      "create_nibble_to_collection": {
        "COLL": "Kolekci",
        "DOC3IF": "Digitální dokument - manifest",
        "IMG3F": "IIIF obraz",
        "REC": "záznam",
        "after_type": "do",
        "before_type": "Přidat",
        "collection": "kolekce"
      },
      "nibble_create_edit": {
        "choose_collection": "Vyberte kolekci",
        "collection": "Kolekce",
        "note": "Poznámka",
        "service": "Název služby",
        "type": "Typ položky"
      }
    },
    "frame_actions": {
      "copy_url_of_top_level_collection": "Kopírovat URL top-level kolekce",
      "create_collection": "Vytvořit kolekci",
      "open_top_level_collection_in_mirador": "Otevřít top-level kolekci v Miradoru"
    },
    "messages": {
      "collection_delete_by_owner": "Požadovaná kolekce byla smazána vlastníkem.",
      "collection_no_nibbles": "Kolekce neobsahuje žádné položky",
      "collection_not_found": "Kolekce \"{{value}}\" nebyla nalezena",
      "collection_published": "🎺 Kolekce publikována",
      "delete_collection_message": "Opravdu chcete smazat kolekci?",
      "delete_collection_title": "Smazat kolekci",
      "feature_not_enabled": "Funkcionalita \"Osobní obsah\" (oblíbené položky, kolekce a další) není aktivována. Pro aktivaci se prosím obraťte na poskytovatele služby.",
      "leave_coop": "Spolupráce na kolekci \"{{value}}\" byla ukončena",
      "nibble_deleted": "Položka \"{{value}}\" byla smazána",
      "nibble_deleted_from_favorites": "Položka \"{{value}}\" byla úspěšně odebrána z oblíbených",
      "no_collections": "Neobsahuje žádné kolekce",
      "no_favorites": "Neobsahuje žádné položky",
      "not_available": "Nevyplněno",
      "open_in_new_window": "Otevřít do nového okna"
    },
    "nibble_comments_dialog": {
      "comment": "Komentář",
      "no_comments": "Nejsou dostupné žádné komentáře",
      "send": "Odeslat",
      "solved": "Vyřešeno",
      "title": "Komentáře"
    },
    "nibble_menu": {
      "add_after": "Přidat novou položku - za",
      "add_before": "Přidat novou položku - před",
      "copy_to": "Kopírovat do ...",
      "copy_url": "Kopírovat URL",
      "download": "Stáhnout",
      "edit": "Upravit",
      "modify_crop_shape": "Upravit tvar výřezu",
      "move_to": "Přesunout do ...",
      "remove": "Odebrat",
      "remove_from_favorites": "Odebrat z oblíbených",
      "show_details": "Zobrazit podrobnosti"
    },
    "nibble_types": {
      "AUD": "URL audio streamu",
      "COLL": "Kolekce",
      "CROP": "Ořez obrazu",
      "DOC": "Digitální dokument",
      "DOC3IF": "Digitální dokument - manifest",
      "IMG": "URL obrazu",
      "IMG3F": "URL obrazu IIIF",
      "LINK": "Obecný odkaz",
      "PAGE": "Stránka komplexního digitálního dokumentu",
      "REC": "Záznam",
      "RECDBOX": "Záznam Dropbox",
      "SRCH": "Rešerše/dotaz",
      "TXT": "Text",
      "VID": "URL video streamu"
    },
    "publish_collection_dialog": {
      "title": "Publikovat kolekci"
    },
    "routes": {
      "coop_default": "Kooperace",
      "dashboard_default": "Přehled"
    },
    "titles": {
      "bulk_delete": "Hromadné mazání",
      "collection": "Kolekce",
      "collection_content": "Obsah kolekce",
      "collection_created": "Kolekce \"{{value}}\" byla vytvořena",
      "collection_deleted": "Kolekce \"{{value}}\" byla smazána",
      "collection_updated": "Kolekce \"{{value}}\" byla upravena",
      "collections": "Kolekce",
      "create_nibble": "Vytvořit položku",
      "credits": "Text poděkování",
      "dateDisseminated": "Datum publikování",
      "dateUpdated": "Datum aktualizace",
      "delete_all_nibbles": "Smazat všechny položky",
      "delete_selected": "Smazat vybrané položky",
      "delete_selected_confirm": "Opravdu chcete smazat vybrané položky?",
      "details": "Podrobnosti",
      "edit_nibble": "Upravit položku",
      "edit_property": "Upravit",
      "info_for_sharing": "Infromace pro sdílení",
      "label": "Titul",
      "license": "CC licenční ujednání, pod kterým bude obsah publikován",
      "new_tag": "Nové klíčové slovo...",
      "nibble_created": "Položka byla vytvořena",
      "nibble_updated": "Položka byla upravena",
      "note": "Anotace",
      "private": "Soukromý",
      "profile": "Profil",
      "pub_image_poster": "Pozadí",
      "pub_label_enter": "Popisek tlačítka vstoupit",
      "pub_og_description": "Krátký popisek pro potřeby sdílení",
      "pub_og_lang": "Převládající jazyk",
      "pub_tags": "Klíčová slova",
      "pub_text_footerAdditional": "Doplněk textu v patičce",
      "pub_text_footerMain": "Text v patičce",
      "pub_text_mission": "Poslání",
      "pub_text_welcome": "Uvítací text",
      "public": "Veřejný",
      "published_collection": "Publikovaná kolekce",
      "search_in_nibbles": "Vyhledat v položkách ({{value}})",
      "select_unselect_all": "Označit/odznačit vše",
      "summary": "Podtitul",
      "type": "Typ kolekce"
    }
  },
  "report": {
    "collapse_all": "Sbalit vše",
    "expand_all": "Rozbalit vše"
  },
  "report_tester": {
    "report_form": {
      "choose_file": "Vybrat soubor",
      "format": "Formát",
      "project": "Projekt",
      "upload": "Nahrát"
    },
    "routes": {
      "json_editor_default": "JSON editor"
    },
    "titles": {
      "report": "Report",
      "upload_xml": "Nahrát XML"
    }
  },
  "resolver": {
    "copy_dialog": {
      "permalink": "Permalink",
      "raw": "Aktuální odkaz",
      "title": "Kopírování"
    }
  },
  "ui": {
    "action_toolbar": {
      "menu": "Menu"
    },
    "buttons": {
      "back": "Zpět",
      "back_to_homepage": "Zpět na domovskou stránku",
      "cancel": "Zrušit",
      "close": "Zavřít",
      "compare": "Porovnat",
      "copy_url_to_clipboard": "Kopírovat URL do schránky",
      "create": "Vytvořit",
      "edit": "Upravit",
      "login": "Přihlásit se",
      "logout": "Odhlásit se",
      "open": "Otevřít",
      "save": "Uložit",
      "settings": "Nastavení"
    },
    "titles": {
      "dashboard_default": "Úvod",
      "instructions": "Návod",
      "language": "Jazyk",
      "not_authorized": "Nemáte přístup",
      "not_found": "Stránka nebyla nalezena"
    }
  },
  "zip_manager": {
    "buttons": {
      "open_in_catalog": "Otevřít v katalogu"
    },
    "delete_dialog": {
      "title": "Opravdu chcete smazat zip balíček?"
    },
    "messages": {
      "html_zip_url_copied": "URL na stránku stahování byla zkopírována do schránky",
      "total_photo_count": "Celkový počet fotek",
      "zip_deleted_success": "Smazání zip balíčku proběhlo úspěšně",
      "zip_renamed_fail": "Zip balíček musí být vždy pojmenovaný",
      "zip_renamed_success": "Přejmenování zip balíčku proběhlo úspěšně"
    },
    "rename_dialog": {
      "confirm_button_label": "Přejmenovat",
      "input_label": "Název",
      "title": "Přejmenování zip balíčku"
    },
    "zip_actions": {
      "copy": "Kopírovat",
      "delete": "Smazat",
      "download": "Stáhnout",
      "open": "Otevřít v nové záložce",
      "rename": "Přejmenovat",
      "search": "Vyhledat"
    },
    "zip_history_table": {
      "actions": "Akce",
      "created_at": "Vytvořeno",
      "download_count": "Počet stažení",
      "expires_at": "Expirace",
      "image_count": "Počet fotek",
      "index": "Index",
      "name": "Název",
      "quality": "Kvalita",
      "search_by_name": "Hledat podle názvu",
      "title": "Zip balíčky"
    }
  }
}
